<template>
  <el-cascader
    v-model="cascaderVal"
    :options="items"
    :props="props"
    :placeholder="attrs.placeholder"
    :show-all-levels="false"
    @change="handleChange"
    collapse-tags
    filterable
    clearable></el-cascader>
</template>

<script>
export default {
  name: 'search-cascader',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    items: Array,
    value: [String, Array],
    attrs: {
      type: Object,
    }
  },
  data() {
    return {
      props: { multiple: true, ...this.attrs.props },
      defaultAttrs: {
        clearable: true,
      },
      cascaderVal: this.value
    }
  },
  watch: {
    value() {
      this.cascaderVal = this.value
    }
  },
  methods: {
    handleChange(v) {
      if(v === null) {
        return this.$emit('change', [])
      };
      return this.$emit('change', v)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
